// @flow
import React from "react";
import { Form } from "react-final-form";
import { FieldControl, FormRow, StaticFieldText } from "buba-components";
import { formatDateFromISO, timeDistanceFromISO } from "buba-components/src/utils/formatters";
import type { BankOfferSubstatus } from "../../../../data/types/bankOffers";

type TimerProps = {
  timeInformation: string,
  status: BankOfferSubstatus
};

const getAction = (status: string) => {
  switch (status) {
    case "opened":
      return "Vorprüfung abschließen";
    case "in_process":
      return "Genehmigung abschließen";
    case "offer_submitted":
      return "Abschluss mitteilen";
    default:
      return "";
  }
};

const Timer = ({ timeInformation, status }: TimerProps) => {
  const isClosed = !["opened", "in_process", "offer_submitted"].includes(status);

  return (
    <Form onSubmit={() => {}}>
      {() => (
        <>
          <header>Aktions-timer</header>
          <FormRow separator={!isClosed}>
            {!isClosed && (
              <>
                <FieldControl caption={() => "Fälligkeitsdatum"}>
                  {() => (
                    <StaticFieldText text={timeInformation && formatDateFromISO(timeInformation)} />
                  )}
                </FieldControl>
                <FieldControl caption={() => "Verbleibende Zeit"}>
                  {() => (
                    <StaticFieldText
                      text={timeInformation && timeDistanceFromISO(timeInformation)}
                    />
                  )}
                </FieldControl>
                <FieldControl caption={() => "Erforderliche Aktion"}>
                  {() => <StaticFieldText text={getAction(status)} />}
                </FieldControl>
              </>
            )}
            {isClosed && (
              <FieldControl caption={() => "Gewähltes Auszahlungsdatum"}>
                {() =>
                  timeInformation && <StaticFieldText text={formatDateFromISO(timeInformation)} />
                }
              </FieldControl>
            )}
          </FormRow>
        </>
      )}
    </Form>
  );
};

export default Timer;
